<template>
    <div class="form__item custom-input">
        <div class="form__label">{{ label }}</div>
        <input class="form__input" :maxlength="maxLength || 100000" :type="inputType || 'text'" :value="value"   @input="handleChange" />
    </div>
</template>
<script>
import { watch } from '@vue/composition-api'
import { reactive } from '@vue/composition-api'

export default {
    name: "Input",
    props: {
        label: String,
        inputType: String,
        maxLength: Number,
        onKeyDown: Function,
        onChange: Function,
        value: String
    },
    setup (props) {
      function handleChange({ target }) {
        props.onChange(target.value.trim());
      }

        return {
            handleChange,
        }
    }
}
</script>
<style lang="scss" scoped>
  .custom-input {
  input {
      max-width: 140px;
      max-height: 35px;
      border: 1px solid #CBD2D9 !important;
      box-sizing: border-box;
      border-radius: 4px !important;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
  }
</style>